import React from 'react';
import { Tag } from 'antd';
import { inboundInvoiceStatus } from 'constants/inboundInvoices';

const InboundInvoiceStatusTag = ({ status }) => {
  const config = inboundInvoiceStatus[status];

  return <Tag color={config?.color || 'default'}>{config?.label || status}</Tag>;
};

export default InboundInvoiceStatusTag;
